export const PATH_UPDATE = 'version/:privacyId';
export const PATH_CREATE = 'create';
export const PATH = '/';
